export const header = (boFlag, fgPOApprovedFlag, columnCustmizeFlage, clickHereToViewBatches) => {
  
  let headerData = [
    {
      id: 'poline',
      numeric: false,
      disablePadding: false,
      label: fgPOApprovedFlag ? 'PO - Line':'PO Number',
      varName: 'POline',
      align: 'left',
      // width: '7%',
    },
    {
      id: 'productCodeDescription',
      numeric: false,
      disablePadding: false,
      label: 'Product Code / Description',
      varName: 'productCodeDescription',
      align: 'left',
      // width: '5%',
    },
  
    {
      id: 'poStatus',
      numeric: false,
      disablePadding: false,
      label: 'PO Status',
      align: 'center',
      varName: 'poStatus',
      // width: '9%',
    },
    {
      id: 'actions',
      numeric: true,
      disablePadding: false,
      label: 'Actions',
      align: 'center',
      varName: 'actions',
      // width: '6%',
    },
  ]

  if (boFlag) {
    headerData.splice(1, 0, {
      id: 'cdmoPlant',
      numeric: false,
      disablePadding: false,
      label: fgPOApprovedFlag ? 'CMO - Plant ID' : 'CMO',
      varName: 'cdmoPlantId',
      align: 'left',
    });
  } else {
    headerData.splice(1, 0, {
      id: 'sponsor',
      numeric: false,
      disablePadding: false,
      label: 'BMS',
      varName: 'Sponsor',
      align: 'left',
    });
  }

  if (fgPOApprovedFlag) {
    let index = 3;
    headerData.splice(index , 0, 
      {
        id: 'dateOfDelivery',
        numeric: false,
        disablePadding: false,
        label: 'Date of Delivery',
        align: 'left',
        varName: 'dateOfDelivery',
        // width: '0%',
      },
      {
        id: 'deliveredQty',
        numeric: true,
        disablePadding: false,
        label: 'Delivered Qty. (%)',
        align: 'right',
        varName: 'deliveredQty',
        // width: '5%',
      });
      if (clickHereToViewBatches) {
        let index = 5;
        headerData.splice(index , 0, {
            id: 'viewBatches',
            numeric: false,
            disablePadding: false,
            label: 'View Batches',
            align: 'center',
            varName: 'viewBatches',
            // width: '0%',
          });
      }
  } else {
    let index = 3;
    headerData.splice(index , 0, 
      {
        id: 'dateOfCreation',
        numeric: false,
        disablePadding: false,
        label: 'Date of Creation',
        align: 'left',
        varName: 'dateOfCreation',
        // width: '0%',
      });
  }

  if (!columnCustmizeFlage || (Array.isArray(columnCustmizeFlage) && columnCustmizeFlage?.length === 0)) {
    return headerData;
  }

   // Filter headerData based on active columnCustmizeFlage
   const activeColumns = columnCustmizeFlage
   .filter(column => column.active)
   .map(column => column.id);

 return headerData.filter(column => activeColumns.includes(column.id));
};

